<template>
  <div :class="lightModeActive ? 'bg-darkModePlayerBG' : ''" class="d-flex flex-column align-items-center border-right">
    <div :class="lightModeActive ? 'bg-documentGray ':'bg-contentPlayerBg'" class="study-drawer">
      <div class="d-flex justify-content-between align-items-start pdl-24 pdr-16 pdt-24 pdb-27">
        <div class="t-color-white">
          <div class="t-subtitle1 t-color-whiteHigh font-m t-line-h-27">{{ basicData && basicData.name }}</div>
        </div>
        <button class="mdc-icon-button mgt--16 mgb--8 mgr--12" tabindex="0">
          <i class="material-icons t-color-whiteHigh study-drawer-toggler-close">
            close
          </i>
        </button>
      </div>
      <div class="mgb-18 bg-whiteBorder w-full h-1"></div>
      <div class="scroll-y h-full scrollable-content pdl-20 pdr-20">
        <!-- slider starts -->
        <div v-if="sectionList.length > 0 && lessonId">
          <div v-show="index === currentSectionIndex"
               v-for="(section, index) in sectionList"
               :key="section.id"
               class="swiper-slide t-color-red">
            <div class="pdt-6 pdb-7 bg-whiteSelected w-full b-radius4 mgb-14 swiper-header">
            <div class="d-flex align-items-center justify-content-between">
              <div class="pdl-30 pdr-30 pdt-13 pdb-3 d-flex align-items-center justify-content-between flex-grow-1">
                <div class="flex-grow-1 d-flex align-items-center t-body6 t-color-commentBlue t-line-h-20 font-b t-line-2 t-center">
                  <div @click="navigateSection(-1)"
                       :class="currentSectionIndex !== 0 ? 'cursor-pointer': 'swiper-button-disabled'"
                       class="swiper-button-prev-menu  study-slider-prev">
                    <i class="material-icons t-color-whiteHigh">keyboard_arrow_left</i></div>
                  {{ section.courseName }}
                  <div @click="navigateSection(1)"
                       :class="currentSectionIndex !== sectionList.length - 1 ? 'cursor-pointer': 'swiper-button-disabled'" class="swiper-button-next-menu  study-slider-next"><i
                      class="material-icons t-color-whiteHigh">keyboard_arrow_right</i>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="pdl-30 pdr-30 pdb-10 d-flex align-items-center justify-content-between flex-grow-1">
                <div class="flex-grow-1 d-flex align-items-center t-body1 t-color-whiteHigh t-line-h-20 font-r t-line-2 t-center mgt-8">
                  {{ section.name }}
                </div>
              </div>
            </div>
            </div>

            <div v-for="(lesson, index) in section.lessons" :key="index" class="">
              <div  class="align-items-center justify-content-between cursor-pointer" @click="moveNextLesson(lesson)" @keypress="moveNextLesson(lesson)">
                <div class="pdl-10 position-relative pdt-13 pdb-12 active d-flex">
                  <div :class="{'study-list': lesson.id !== lessonId}" class="left-content mgr-16 position-relative">
                    <i :class="{'show': lesson.rate === 100 }" class="material-icons t-color-saleLine icon-done">check_circle</i>
                    <!-- <i :class="{'t-color-whiteHigh': lesson.id !== lessonId}" class="material-icons t-color-bodyGrayA font-20" v-html="lessonTypeCal(lesson.contents)"></i> -->
                    <i :class="lesson.id !== lessonId ? 't-color-bodyGrayA' : 't-color-whiteHigh'" class="material-icons  font-20" v-html="lessonTypeCal(lesson.contents)"></i>
                    <div class="total">
                      <span v-if="lesson.id === lessonId" id="updateRate" :style="{width: (updateRate === lesson.rate ? lesson.rate : updateRate) +'%'}" class="real"></span>
                      <span v-else id="regularRate" :style="{width: lesson.rate+'%'}" class="real"></span>
                    </div>
                  </div>
                  <!-- <div :class="{'study-list': lesson.id !== lessonId}" class="t-body3 list-content t-line-h-28">{{ lesson.name }}</div> -->
                  <div :class="lesson.id === lessonId ? 'active':'study-list'" class="t-body3 list-content t-line-h-28">{{ lesson.name }}</div>
                </div>
              </div>
              <div class=" bg-whiteBorder w-full h-1"></div>
            </div>
          </div>
        </div>
        <!-- slider ends -->
      </div>
    </div>
    <div class="backdrop-study-drawer d-none"></div>
  </div>
</template>

<script>
import microLearnApi from "@/api/microLearnApi";

export default {
  name: "LCMSLeftBar",

  props: ['lightModeActive', 'basicData', 'lessonName', 'sectionList', 'updateRate'],

  data() {
    return {
      currentSectionIndex: 0,
      columViewSelected: false,
      lessonId: parseInt(this.$route.params.lessonId)
    };
  },

  mounted() {
    this.currentSectionIndex = this.sectionList.findIndex((section) => {
      return section.lessons.some(lesson => {
        return parseInt(lesson.id) === this.lessonId;
      })
    });

    if(document.querySelector('.study-drawer-toggler')) {
      var studyDrawerOpen = document.querySelector('.study-drawer-toggler');
      studyDrawerOpen.addEventListener('click', () => {
        document.querySelector('.study-drawer').classList.add('open');
        document.querySelector('.backdrop-study-drawer').classList.remove('d-none');
        var swiperHeaderHeight = $('.swiper-header').height();
        $('.study-slider-prev').css('height', swiperHeaderHeight);
        $('.study-slider-next').css('height', swiperHeaderHeight);
      });
    }

    if(document.querySelector('.study-drawer-toggler-close')) {
      var studyDrawerClose = document.querySelector('.study-drawer-toggler-close');
      studyDrawerClose.addEventListener('click', function() {
        document.querySelector('.study-drawer').classList.remove('open');
        document.querySelector('.backdrop-study-drawer').classList.add('d-none');
      });
    }

    if(document.querySelector('.backdrop-study-drawer')) {
      var studyDrawerClose = document.querySelector('.backdrop-study-drawer');
      studyDrawerClose.addEventListener('click', function() {
        document.querySelector('.study-drawer').classList.remove('open');
        document.querySelector('.backdrop-study-drawer').classList.add('d-none');
      });
    }
  },

  methods: {
    lessonTypeCal(val) {
      if(val.exam !== null) {
        return 'calculate'
      }
      if(val.meeting !== null) {
        return 'videocam'
      }
      const valType = val.lcms.type.value;
      switch (valType) {
        case 'COMPUTER_SCIENCE' :
          return 'code';
        case 'VIDEO' :
          return 'play_circle';
        case 'PDF' :
          return 'picture_as_pdf';
        case 'HTML' :
          return 'description';
        case 'INTERACTIVE_HTML' :
          return 'description';
        case 'SLIDE' :
          return 'description';
        case "EXAM":
          return 'grid_view';
        default:
          return 'description';
      }
      // TODO: unfold_more 컨디션의 경우 <i class="material-icons rotate-90">unfold_more</i> 아이콘 추가
    },

    setParams() {
      const params = {
        learnId: this.$route.params.learnId
      }
      return params
    },

    navigateSection(direction) {
      const newIndex = this.currentSectionIndex + direction;
      if (newIndex >= 0 && newIndex < this.sectionList.length) {
        this.currentSectionIndex = newIndex;
      }
    },

    moveNextLesson(lesson) {
      if (lesson.status.value === 'OPENED' ) {
        if (this.$route.params.lessonId === lesson.id) {
          return;
        } else {
          if (lesson.resourceType.value === 'EXAM') {
            this.$router.push({
              name: 'MicroExamIntro',
              params: {
                learnId: this.$route.params.learnId,
                examineeId: lesson.examineeId
              },
              query: this.$route.query
            })
          } else if(lesson.resourceType && lesson.resourceType.value === 'LIVE_SESSION') {
            let params = {
              learnId: this.$route.params.learnId,
              progressionId: lesson.progressionId
            }
            microLearnApi.learnLessonContents(params).then((response) => {
              let liveSessionTrueFalse = response.data.data.liveSession.canParticipate;
              if(liveSessionTrueFalse === false) {
                this.$alert({
                  title: this.$t("3434"), // 학습을 중단한 강의입니다.
                  content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                  accept: this.$t("3436"), // 확인
                }).then(() => {}).catch(() => {});
              } else {
                let responseData = response.data.data
                let liveSessionData = responseData
                this.zoomMeeting(lesson, liveSessionData);
              }
            }).catch((err) => {})
        } else {
            this.$router.push({
              name: 'MicroDegreeLessonView',
              params: {
                learnId: parseInt(this.$route.params.learnId),
                lessonId: lesson.id,
                progressionId: lesson.progressionId
              },
              query: this.$route.query
            })
          }
        }
      } else {
        this.$alert({
          content: '<div id="slidePopup" >'+this.$t('1885')+"<br/>"+this.$t('1886')+'</div>',
          accept:  this.$t('1887'),
        }).then(() => {})
      }
    },

    zoomMeeting(lesson, liveSessionData, target='_blank', rel="noopener noreferrer"){
      window.open(liveSessionData.liveSession.url, target,rel);
      this.$emit('updateProgress', lesson);
    },

    darkModeToLight() {
      this.$emit('darkModeToLight');
    },

    columViewInActive() {
      this.$emit('columViewActive', false);
      this.columViewSelected = false;
    },

    columViewActive() {
      this.$emit('columViewActive', true);
      this.columViewSelected = true;
    },
  }
}
</script>

<style scoped>
.swiper-button-next-menu.study-slider-next {
  /* background-image: url('../../../../../src/images/study-right-arrow.svg'); */
  right: 10px !important;
  align-items: center;
}
.swiper-button-prev-menu.study-slider-prev {
  /* background-image: url('../../../../../src/images/study-left-arrow.svg'); */
  left: 10px !important;
  align-items: center;
}
.swiper-button-disabled{
  opacity: 0.13 !important;
}
.swiper-button-prev-menu, .swiper-button-next-menu {
  position: absolute;
  top: 30px;
  width: 27px;
  height: 44px;
  z-index: 10;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
